module.exports = __webpack_public_path__ + "static/media/40.4108cb3b.png";